module.exports = __webpack_public_path__ + "static/media/Temp-CWU.e97e9e4f.svg";